import { BrandName } from 'src/@enums'
import { getConfig } from './getConfig'

const appConfig = getConfig()

export const MAX_VIEWPORT_WIDTH = 560

const BrandBackground: Record<BrandName, string> = {
  [BrandName.EUDORA]:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/EUD/desk_pattern_eud.jpg',
  [BrandName.BOTICARIO]:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/desk_pattern_bot.jpg',
  [BrandName.EU_AMO_MAKE]:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/EAM/desk_pattern_eam.jpg',
  [BrandName.OUI]: '',
  [BrandName.MULTIMARCAS]: '',
}

export const getBackground = () => {
  const { brandEnv } = appConfig

  return BrandBackground[brandEnv]
}

export const headerHeight = { mobile: 60, desktop: 120 }
